export const Data = {
  light: [
    {
      img: "light_1.jpg",
      locations: [
        {
          coordinates: [-5, -140],
          index: 1
        },
        {
          coordinates: [-5, -190],
          index: 2
        }
      ]
    },
    {
      img: "light_2.jpg",
      locations: [
        {
          coordinates: [-5, 167],
          index: 2
        }
      ]
    },
    {
      img: "light_3.jpg",
      locations: [
        {
          coordinates: [-5, -40],
          index: 0
        },
        {
          coordinates: [-5, -100],
          index: 1
        }
      ]
    },
    {
      img: "light_4.jpg",
      locations: [
        {
          coordinates: [-5, -1],
          index: 1
        }
      ]
    }
  ],
  dark: [
    {
      img: "dark_1.jpg",
      locations: [
        {
          coordinates: [-5, -140],
          index: 1
        },
        {
          coordinates: [-5, -190],
          index: 2
        }
      ]
    },
    {
      img: "dark_2.jpg",
      locations: [
        {
          coordinates: [-5, 167],
          index: 2
        }
      ]
    },
    {
      img: "dark_3.jpg",
      locations: [
        {
          coordinates: [-5, -40],
          index: 0
        },
        {
          coordinates: [-5, -100],
          index: 1
        }
      ]
    },
    {
      img: "dark_4.jpg",
      locations: [
        {
          coordinates: [-5, -1],
          index: 1
        }
      ]
    }
  ]
}
